import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePipe } from './date.pipe';
import { DurationPipe } from './duration.pipe';
import { WeekPipe } from './week.pipe';
import { AdjustUtcDatePipe } from './adjust-utc-date/adjust-utc-date.pipe';

@NgModule({
    declarations: [DatePipe, WeekPipe, DurationPipe, AdjustUtcDatePipe],
    imports: [CommonModule],
    exports: [DatePipe, WeekPipe, DurationPipe, AdjustUtcDatePipe],
    providers: [DatePipe, WeekPipe, DurationPipe, AdjustUtcDatePipe],
})
export class DatePipeModule {}
